import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SituConnectSummary } from 'situanalytics-webapi-client';

@Component({
  selector: 'situ-connect-config-list-card',
  templateUrl: './situ-connect-config-list-card.component.html',
  styleUrls: ['./situ-connect-config-list-card.component.scss']
})
export class SituConnectConfigListCardComponent implements OnInit {
  /* standard */
  @Input() isAdmin: boolean = false;
  @Input() isSituUser: boolean = false;
  @Input() isDarkMode: boolean = false;
  @Input() item: SituConnectSummary | undefined;

  @Input() viewSituConnectId: string | undefined;

  @Output() selectedConnectItem = new EventEmitter<SituConnectSummary>();

  constructor() {}

  ngOnInit(): void {
  }

  getIconType(connectType: string): string {
    switch (connectType) {
      case 'draftsitulinkpanoramas':
      case 'situlinkpanoramas':
      case 'hdsitulinkpanoramas':
        return 'panorama'; // the icon for panorama
      case 'facade':
      case 'hdfacade':
        return 'photo'; // the icon for photo
      default:
        return 'panorama'; // fallback icon
    }
  }
  getConnectTypeTooltip(connectType: string): string {
    switch (connectType) {
      case 'draftsitulinkpanoramas':
        return 'situVIEW';
      case 'situlinkpanoramas':
        return 'situVIEW HD';
      case 'hdsitulinkpanoramas':
        return 'situVIEW HD+';
      case 'facade':
        return 'situFACADE';
      case 'hdfacade':
        return 'situFACADE HD';
      default:
        return 'Unknown Type';
    }
  }
  getIconColor(connectType: string): string {
    switch (connectType) {
      case 'draftsitulinkpanoramas':
        return 'rgba(106, 76, 147, 1)'; // purple
      case 'situlinkpanoramas':
        return 'rgba(25, 130, 196, 1)'; // blue
      case 'hdsitulinkpanoramas':
        return 'rgba(20, 193, 245, 1)'; // light blue
      case 'facade':
      case 'hdfacade':
        return 'rgba(255, 89, 94, 1)'; // red
      default:
        return 'rgba(0, 0, 0, 1)'; // default black
    }
  }
  isViewable(connectType: string): boolean {
    switch (connectType) {
      case 'draftsitulinkpanoramas':
      case 'situlinkpanoramas':
      case 'hdsitulinkpanoramas':
      case 'facade':
      case 'hdfacade':
        return true;
      default:
        return false;
    }
  }

  select() {
    this.selectedConnectItem.emit(this.item);
  }

  isRecent(createTime: Date) {
    let date = new Date();
    date.setMinutes(date.getMinutes() - 15);
    return createTime > date; 
  }
}

export class SituConnectLoadItem {
  constructor(public artifactId: string, public connectType: string) {
  }
}